<template>
  
    <el-container>
     
      <el-main>
       <h1>Create basic mode mindmap</h1>
       <h2>Method 1</h2>
       <p>Add yaml to markdown:</p>
       <pre>
        <code>
---

mindmap-plugin: basic

---
        </code>
       </pre>
       <p>Then you can find <i>Open as mindmap</i> menu in more options</p>
       <div>
          <img src="../assets/markmind/basic.gif" alt="" width="800">
       </div>

       <h2>Method 2</h2>
       <p>Right click in folder , click <i>New mindmap board</i> menu</p>

        <div>
          <img src="../assets/markmind/basic2.gif" alt="" width="800">
       </div>

       <h3>basic mode will output this markdown:</h3>

       <pre>
        <code>
---

mindmap-plugin: basic

---

# Mark mind for obsidian

## Links
- https://github.com/MarkMindLtd/obsidian-markmind
- [GitHub](https://github.com/MarkMindLtd/obsidian-markmind)

## Related
- [coc-markmap](https://github.com/gera2ld/coc-markmap)
- [gatsby-remark-markmap](https://github.com/gera2ld/gatsby-remark-markmap)

## Features
- links
- **inline** ~~text~~ *styles*
- multiline
   text
- `inline code`
- Katex - $x = {-b \pm \sqrt{b^2-4ac} \over 2a}$
        </code>
       </pre>

      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'BasicModePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
